// Styles
import IframeContainer from "../IframeContainer.styles";
import PowerBIDashboard from "../../../components/Common/PowerBIDashboard";
import React from "react";

type Props = {};

export default function PublicCompanies({}: Props) {
    return (
        <IframeContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="aae307bb-036b-4da8-854e-e2b0877d4315"
                    workspaceId="0ab7398c-fff1-4373-b543-e7d6d23657cd"
                ></PowerBIDashboard>
            </div>
        </IframeContainer>
    );
}
